<template>
    <div class="col-6">
        <div class="my-3">{{ title }}</div>
        <div class="py-4 px-3 border">
            <div class="mb-2">
                {{ $t("lbl_EMPBE_VGProductSelection")}}
            <a v-b-toggle.sidebar-VG><i class="text-dark fa fa-info-circle"></i></a>
            </div>

            <productSelection v-model="SelectedAllSupplierProd" :valueId="SelectedAllSupplierProdId"
                            :supplierId="supplierId" :usagetype="usagetype" ref="ProdSelection"></productSelection>
        </div>
        
    </div>
</template>

<script>
import { computed } from "vue";

    export default{

        props:["data"],
        data(){
            return{
                usagetype:"photo",
                supplierId:this.companyid,
                SelectedAllSupplierProdId: this.data.productid,
                SelectedAllSupplierProd:null
            }
        },
        computed:{
            user() {
                
            return this.$store.state.authentication.user;
            },
            companyid() {
            return this.supplierId 
                ? this.user.empCompanyId
                : this.supplierId;
            },
            title(){
                switch(this.data.type){
                    case("All"):
                        return this.$t('lbl_EMPBE_AllIndustriesVer')
                    case("Auto"):
                        return this.$t('lbl_EMPBE_VerAutomotive')
                    case("EE"):
                        return this.$t('lbl_EMPBE_VerEE')
                    case("Pack"):
                        return this.$t('lbl_EMPBE_VERPackaging')
                    default:
                        return ""
                }
            }
        },
        watch:{
            SelectedAllSupplierProd(newValue, oldValue){
                var formRid = this.data.rid;
                var formObj = {
                    productId: null,
                    vgId : formRid
                }
                //associate vg rid to selection
                if(newValue){
                    //is add
                    formObj.productId = newValue.id   
                }
                else{
                    //is remove, pass the old value , assign -1 product id to it, and delete -1 id in store proc 
                    formObj.productId= -1
                } 
                this.$emit("form_vgSelected",formObj, formRid)

            }
        }
    }
</script>

<style>
.border{
    border:1px black solid
}
</style>